import React from "react";
import PropTypes from "prop-types";
/* Components */
import Parameter from "../CommonForBoth/Parameter";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Card } from "semantic-ui-react";
/* i18n */
import { withTranslation } from "react-i18next";
/* Helpers */
import { etherscanLink } from "@/helpers/ensuro_helper";
import colors from "@/colors";

const ETokenParams = ({ t, pas, address, internalLoanInterestRate, minUR, maxUR, assetManager }) => {
  return (
    <Card fluid className="params">
      <a target="_blank" className="right-aligned" rel="noopener noreferrer" href={etherscanLink(address)}>
        <p className="font-size-14">
          {t("ViewContractInBlockExplorer")} <i className="uil uil-external-link-alt" />
        </p>
      </a>
      <br />
      <Parameter
        name={t("Pool Loan Interest Rate")}
        value={internalLoanInterestRate}
        suffix={"%"}
        percentage={true}
        options={{ maximumFractionDigits: 2, notation: "standard" }}
      />
      <hr style={{ width: "90%", color: colors.secondary, marginTop: "0" }} />
      <Parameter
        name={t("Min Utilization Rate")}
        value={minUR}
        suffix={"%"}
        percentage={true}
        options={{ maximumFractionDigits: 2, notation: "standard" }}
      />
      <hr style={{ width: "90%", color: colors.secondary, marginTop: "0" }} />

      <Parameter
        name={t("Max Utilization Rate")}
        value={maxUR}
        suffix={"%"}
        percentage={true}
        options={{ maximumFractionDigits: 2, notation: "standard" }}
      />

      <hr style={{ width: "90%", color: colors.secondary, marginTop: "0" }} />
      <Parameter name={t("Asset Manager")} value={{ state: assetManager.am, address: true }} renderType={"address"} />
      {pas && (
        <>
          <hr style={{ width: "90%", color: colors.secondary, marginTop: "0" }} />
          <Row>
            <Col md={5} xs={6}>
              <p>
                <strong>{t("Risk Partners")}</strong>
              </p>
            </Col>
            {pas.map((pa, idx) => (
              <React.Fragment key={idx}>
                <Col md={7} xs={6} className="params-value params-col">
                  <Link to={`/portfolios/${pa.address}`}>
                    <p>{pa.name}</p>
                  </Link>
                </Col>
                <Col md={5} xs={6}></Col>
              </React.Fragment>
            ))}
          </Row>
        </>
      )}
    </Card>
  );
};

ETokenParams.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(ETokenParams);
